import React, { useEffect, useState } from "react";
import { Box, Grid, Card } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Helmet } from "react-helmet";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import OEE from "../../components/chart/nongjok/OEE";
import APQ from "../../components/chart/nongjok/APQ";
import BarChartAccumulativeProduction from "../../components/chart/BarChartAccumulativeProduction";
import BarChartAccumulativeTable from "../../components/chart/nongjok/BarChartAccumulativeTable";
import LensIcon from '@mui/icons-material/Lens';
import Fighting from '../../assets/img/renewal.png';
import moment from 'moment-timezone';
import CardContent from '@mui/material/CardContent';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CancelIcon from '@mui/icons-material/Cancel';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ExportExcel from "../../components/model/exportExcel";
import db from "../../firebase-config"


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#f2f2f2',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  height: '100%',
  color: theme.palette.text.secondary,
}));



const ITEM_HEIGHT = 48;


export default function Home() {
  const today = new Date();
  const hourago = new Date(today.getTime());
  const hourago_subtract = new Date(today.getTime() - (24 * 60 * 60 * 1000));
  const timestr = moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD');
  const timestr_subtract = moment(hourago_subtract).tz('Asia/Bangkok').format('YYYY-MM-DD');
  const hour = moment(hourago).tz('Asia/Bangkok').format('HH');


  const [productionDetail, setProductionDetail] = useState([]);
  const [oeeDashboard, setOeeDashboard] = useState([]);

  const [getYield, setGetYield] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openReport, setOpenReport] = useState(false);
  const [start_data_report, setStart_data_report] = useState(moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD'));
  const [end_data_report, setEnd_data_report] = useState(moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD'));

  const [report_OEE, setReport_OEE] = useState([]);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleClickOpenReport = () => {
    setOpenReport(true);
  };

  const handleCloseReport = () => {
    setOpenReport(false);
  };

  const options = [
    {
      list: 'Report OEE',
      onClick: handleClickOpenReport
    }
  ];


  useEffect(() => {
    const today = moment().format("YYYY-MM-DD");
    const oeeSubscribe = db
      .collection("prod_mes_ignition_nongjok_oee")
      .onSnapshot((querySnapshot) => {
        const oeeDocs = [];

        querySnapshot.forEach((doc) => {
          const data = { ...doc.data(), id: doc.id };
          if (doc.id.includes(`4046_CURRENT_OEE_${today}`)) {
            oeeDocs.push(data);
          }
        });
        const lastOee = oeeDocs[oeeDocs.length - 1];

        if (lastOee) {
          setOeeDashboard(lastOee);
        } else {
          setOeeDashboard([]);
        }

      });

    const subscriberProductionDetail = db
      .collection("prod_mes_ignition_nongjok_production_detail")
      .onSnapshot((querySnapshot) => {
        const productionDocs = [];

        querySnapshot.forEach((doc) => {
          const data = { ...doc.data(), id: doc.id };
          if (data.DATE === today) {
            productionDocs.push(data);
          }
        });
        const production = productionDocs;

        if (production) {
          setProductionDetail(production);
        } else {
          setProductionDetail([]);
        }

      });

    return () => {
      oeeSubscribe();
      subscriberProductionDetail();
    };
  }, []);

  const accumulate_target = productionDetail.reduce((a, v) => a = a + v.TARGET, 0);

  const accumulate_actual = productionDetail.reduce((a, v) => a = a + v.ACTUAL_OUTPUT, 0)


  return (
    <>
      <Helmet>
        <title>Home | Dashboard Nongjok</title>
      </Helmet>
      <Grid
        container spacing={1}
        direction="row"
        alignItems="top"
        justifyContent="center"
        style={{ minHeight: '78vh', maxHeight: '200vh', flexGrow: 1, paddingLeft: 0, paddingTop: 0, paddingRight: 15 }}
      >
        {/* Top row */}

        {/* left column */}
        <Grid container spacing={3} /*style={{ position: "relative", top: "10px", left: "-12px" }}*/>
          <Grid item xs={12} md={7} lg={7} xl={7}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12} xl={12}>
                <Item>
                  <Box width="100%" sx={{ background: "#3cbea8" }}>
                    <Grid container spacing={0}>
                      <Grid item xs={11} md={11} lg={11} xl={11} textAlign="center">
                        <Typography fontSize={'22px'} fontWeight="medium" style={{ color: "white" }}>
                          ข้อมูลการผลิต
                        </Typography>
                      </Grid>
                      <Grid item xs={1} md={1} lg={1} xl={1} textAlign="left" >
                        {/*<Tooltip title="Report OEE">*/}
                        {/* <IconButton
                          aria-label="more"
                          id="long-button"
                          aria-controls={open ? 'long-menu' : undefined}
                          aria-expanded={open ? 'true' : undefined}
                          aria-haspopup="true"
                          onClick={handleClick}
                        >
                          <Button variant="text" style={{ width: '90px', height: '5px', fontWeight: 'bold' }} ><MoreVertIcon sx={{ color: '#ffffff' }} style={{ position: "relative", top: "0.2vw" }} /></Button>

                        </IconButton>
                        <Menu
                          id="long-menu"
                          MenuListProps={{
                            'aria-labelledby': 'long-button',
                          }}
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          PaperProps={{
                            style: {
                              maxHeight: ITEM_HEIGHT * 4.5,
                              width: '20ch',
                            },
                          }}
                        >
                          {options.map((option) => (
                            <MenuItem key={option.list} selected={option === 'Pyxis'} onClick={handleClose}>
                              <div onClick={option.onClick}>{option.list}</div>
                            </MenuItem>
                          ))}
                        </Menu> */}

                        {/* 
                        <Dialog
                          open={openReport}
                          onClose={handleCloseReport}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <Typography style={{ width: '200px', fontSize: '22px', fontWeight: 'medium', position: "relative", top: "5px", left: "10px" }}>
                            Report OEE
                          </Typography>
                          <DialogContent>
                            <Box width='100%' style={{ position: "relative", top: "-5px", left: "-10px" }} >
                              <Typography style={{ fontSize: '16px', fontWeight: 'medium' }}>
                                วันที่แผนผลิต(เริ่มต้น)
                              </Typography>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={1}>
                                  <DatePicker
                                    //style={{width:300}}
                                    inputFormat="YYYY-MM-DD"
                                    //label="Select date"
                                    value={start_data_report}
                                    onChange={(newValue) => {
                                      //////Get React DatePicker date value in onChange(https://stackoverflow.com/questions/70182747/get-react-datepicker-date-value-in-onchange)
                                      const d = new Date(newValue);
                                      const formatted = moment(d).tz('Asia/Bangkok').format('YYYY-MM-DD');
                                      setStart_data_report(formatted)
                                      //console.log("date: " + formatted);
                                    }}

                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        sx={{
                                          width: '100%',
                                          svg: { color: '#000000' },
                                          "& .MuiOutlinedInput-input": {
                                            color: "#000000",
                                            //fontFamily: 'Monospace',
                                            fontWeight: "bold",
                                            fontSize: 16
                                          },
                                          '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                              borderColor: '#c4c2c2',
                                            },
                                            '&:hover fieldset': {
                                              borderColor: '#c4c2c2',
                                            },
                                            '&.Mui-focused fieldset': {
                                              borderColor: '#c4c2c2',
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                </Stack>
                              </LocalizationProvider>
                            </Box>

                            <Box width='100%' style={{ position: "relative", top: "-5px", left: "-10px" }} >
                              <Typography style={{ fontSize: '16px', fontWeight: 'medium' }}>
                                วันที่แผนผลิต(สิ้นสุด)
                              </Typography>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Stack spacing={1}>
                                  <DatePicker
                                    //style={{width:300}}
                                    inputFormat="YYYY-MM-DD"
                                    //label="Select date"
                                    value={end_data_report}
                                    onChange={(newValue) => {
                                      //////Get React DatePicker date value in onChange(https://stackoverflow.com/questions/70182747/get-react-datepicker-date-value-in-onchange)
                                      const d = new Date(newValue);
                                      const formatted = moment(d).tz('Asia/Bangkok').format('YYYY-MM-DD');
                                      setEnd_data_report(formatted)
                                      //console.log("date: " + formatted);
                                    }}

                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        sx={{
                                          width: '100%',
                                          svg: { color: '#000000' },
                                          "& .MuiOutlinedInput-input": {
                                            color: "#000000",
                                            //fontFamily: 'Monospace',
                                            fontWeight: "bold",
                                            fontSize: 16
                                          },
                                          '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                              borderColor: '#c4c2c2',
                                            },
                                            '&:hover fieldset': {
                                              borderColor: '#c4c2c2',
                                            },
                                            '&.Mui-focused fieldset': {
                                              borderColor: '#c4c2c2',
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                </Stack>
                              </LocalizationProvider>
                            </Box>
                          </DialogContent>
                          <DialogActions>
                            <Button variant="contained" style={{ borderRadius: 10, fontSize: 14, background: '#9c9797' }} onClick={handleCloseReport}> <CancelIcon />&nbsp;Cancel</Button>
                            <ExportExcel excelData={report_OEE} fileName={"Report OEE"} />
                          </DialogActions>
                        </Dialog> */}
                        {/*</Tooltip>*/}
                      </Grid>
                    </Grid>
                  </Box>
                  <Box mb={1} pt={0} px={2} display="flex" justifyContent="space-between" alignItems="center" style={{ position: "relative", top: "-20px", left: "0px" }}>
                    <Grid container spacing="15px" alignItems="left" justifyContent="center">
                      {/* oee */}
                      <Grid item xs={6} md={3} lg={3} xl={3}>
                        {oeeDashboard?.OEE > 100 ?
                          <OEE
                            value={[100]}
                            title='OEE'
                          />
                          : <OEE
                            value={[oeeDashboard?.OEE === 'NA' || oeeDashboard?.OEE === undefined ? 0 : Math.round(oeeDashboard?.OEE)]}
                            title='OEE'
                          />
                        }
                      </Grid>
                      {/* a */}
                      <Grid item xs={6} md={3} lg={3} xl={3}>
                        {oeeDashboard?.A > 100 ?
                          <APQ
                            value={[100]}
                            title='AVA'
                            target='92'
                          />
                          : <APQ
                            value={[oeeDashboard?.A === 'NA' || oeeDashboard?.A === undefined ? 0 : Math.round(oeeDashboard?.A)]}
                            title='AVA'
                            target='92'
                          />
                        }
                      </Grid>
                      {/* p */}
                      <Grid item xs={6} md={3} lg={3} xl={3}>
                        {oeeDashboard?.P > 100 ?
                          <APQ
                            value={[100]}
                            title='PER'
                            target='95'
                          />
                          : <APQ
                            value={[oeeDashboard?.P === 'NA' || oeeDashboard?.P === undefined ? 0 : Math.round(oeeDashboard?.P)]}
                            title='PER'
                            target='95'
                          />
                        }
                      </Grid>
                      {/* q */}
                      <Grid item xs={6} md={3} lg={3} xl={3}>
                        {oeeDashboard?.Q > 100 ?
                          <APQ
                            value={[100]}
                            title='QUA'
                            target='98'
                          />
                          : <APQ
                            value={[oeeDashboard?.Q === 'NA' || oeeDashboard?.Q === undefined ? 0 : Math.floor(oeeDashboard?.Q)]}
                            title='QUA'
                            target='98'
                          />
                        }
                      </Grid>
                    </Grid>
                  </Box>
                  {/* ผลผลิตสะสม */}
                  <Box pt={1} px={2.5} display="flex" justifyContent="space-between" alignItems="center" style={{ position: "relative", top: "15px", left: "0px" }}>
                    <Grid sx={12} container spacing="7px" alignItems="center" justifyContent="center" >
                      <Grid sm={12} container spacing="5px" alignItems="center" justifyContent="center" >
                        <Grid item xs={12} md={7} lg={7} xl={7}>
                          <Card sx={{ bgcolor: "#ECF8F8" }} style={{ position: "relative", margin: "auto" }}>
                            <table style={{ 'padding-top': '30px' }}>
                              <tbody>
                                <tr>
                                  <td align="right" style={{ width: '75px', fontSize: 18, fontWeight: 'bold', borderBottom: 'none', height: "1px", color: "black" }}>ผลผลิตสะสม</td>
                                  <td align="left" >
                                    {productionDetail.length != 0 ?
                                      <BarChartAccumulativeProduction
                                        target_quantity={accumulate_target}
                                        actual_weight={accumulate_actual}
                                        target_now={0}
                                        unit='PAK'
                                        height='60%'
                                      />
                                      : <BarChartAccumulativeProduction
                                        target_quantity={0}
                                        actual_weight={0}
                                        target_now={0}
                                        unit='PAK'
                                        height='60%'
                                      />
                                    }
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={5} lg={5} textAlign="left">
                          <Card sx={{ height: '95px', bgcolor: "#ECF8F8", display: 'flex', alignItems: 'center', justifyContent: 'center' }} style={{ position: "relative", left: '0px', top: '0px', borderRadius: 5 }}>
                            <CardContent>
                              <Typography style={{ color: "#000000", fontSize: 22, fontWeight: 'bold', top: "0px" }} textAlign="center">
                                <img src={Fighting} height="30px" /> Performance
                              </Typography>
                              <Typography style={{ color: "#000000", fontSize: 24, fontWeight: 'bold', position: "relative", left: "0px", top: "5px" }} textAlign="center">
                                {oeeDashboard?.PERFORMANCE === undefined || oeeDashboard?.PERFORMANCE === 'NA' ? 'NA' : (oeeDashboard?.PERFORMANCE).toFixed(2).toLocaleString()}&nbsp;&nbsp;kg/hr&nbsp;&nbsp;(std. {oeeDashboard?.STD_PERFORMANCE === undefined || oeeDashboard?.STD_PERFORMANCE === 'NA' ? 'NA' : Math.round(oeeDashboard?.STD_PERFORMANCE).toLocaleString()})
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                  {/* Yield */}
                  <Box pt={1.5} px={3.5} display="flex" justifyContent="space-between" alignItems="left">
                    <Grid container spacing={{ xs: 3, md: 3 }} columns={{ xs: 6, sm: 8, md: 12 }}>
                      <Card sx={{ height: '200px' }} style={{ position: "relative", top: "35px" }}>
                      </Card>
                      {/*arrToObjectYield != 0 ? arrToObjectYield.map((item) => {
                        return (
                          <Grid item xs={3} style={{ position: "relative", padding: 10 }}>
                            <GaugeChartYield
                              title={'Yield: ' + item.name}
                              value={[Math.floor(item.value)]}
                              input={'NA'}
                              output={'NA'}
                            />

                          </Grid>
                        )
                      }) : <Grid item xs={3} style={{ position: "relative", padding: 2 }}>
                        <GaugeChartYield
                          title='Yield'
                          value={[0]}
                          input={'NA'}
                          output={'NA'}
                        />
                      </Grid>
                      */}
                    </Grid>
                  </Box>
                </Item>
              </Grid>
            </Grid>
          </Grid>
          {/* right column */}

          {productionDetail.length > 4
            ? <Grid item xs={12} md={5} lg={5} xl={5} >
              <Item >
                <Box width="100%" sx={{ background: "#3cbea8" }}>
                  <Typography fontSize={'22px'} fontWeight="medium" style={{ color: "white" }}>
                    รายการสินค้า&nbsp;&nbsp;&nbsp;
                  </Typography>
                </Box>
                <Box pt={3} px={0.5} pl={1.5} display="flex" justifyContent="space-between" alignItems="left" >
                  <Grid container spacing={{ xs: 1, md: 1 }} columns={{ xs: 1, sm: 1, md: 12 }}>
                    {productionDetail.map((item) => {
                      let colorStroke = item.STATUS == 'Running' ? "#00d084" : item.STATUS == 'Completed' ? "#00d084" : "#FFFFFF"

                      const getColor = () => {
                        let color;
                        try {
                          if (item.STATUS == 'Completed') {
                            color = "#00d084"
                          } else if (item.STATUS == 'Running') {
                            color = "#e0e0e0"
                          } else if (item.STATUS == 'Not Start') {
                            color = "#FFFFFF"
                          }
                          return color;
                        }
                        catch {
                          console.log()
                        }
                      }
                      return (
                        <Grid item xs={6} style={{ position: "relative", padding: 2 }}>
                          <Card sx={{ width: "100%", bgcolor: "#ECF8F8", display: 'flex', alignItems: 'left', justifyContent: 'left' }} textAlign="left" >
                            <CardContent>
                              <Typography style={{ color: "#000000", fontSize: "14px", position: "relative", left: '0vw', top: "-5px" }} textAlign="left">
                                <LensIcon fontSize="small" stroke={colorStroke} strokeWidth="2" sx={{ color: getColor() }} style={{ position: "relative", left: '0px', top: '5px' }}>{item.STATUS} </LensIcon> {item.MATERIAL_DESCRIPTION}
                              </Typography>
                              <Typography style={{ color: "#ffffff", fontSize: "16px", position: "relative", left: '-10px', top: "10px" }} textAlign="left">
                                <BarChartAccumulativeTable
                                  target={item.TARGET}
                                  actual_output={item.ACTUAL_OUTPUT}
                                  status={item.STATUS}
                                  target_now={0}
                                  unit='PAK'
                                  height='50%'
                                  width='55%'
                                />
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      )
                    })}
                  </Grid>
                </Box>
              </Item>
            </Grid>
            : <Grid item xs={12} md={5} lg={5} xl={5} >
              <Item >
                <Box width="100%" height="6%" sx={{ background: "#3cbea8" }}>
                  <Grid container spacing={0}>
                    <Grid item xs={12} md={12} lg={12} xl={12} textAlign="center">
                      <Typography fontSize={'22px'} fontWeight="medium" style={{ color: "white" }}>
                        รายการสินค้า
                      </Typography>
                    </Grid>

                  </Grid>
                </Box>
                <Box pt={4.2} px={3.5} display="flex" justifyContent="space-between" alignItems="left">
                  <Grid container spacing={{ xs: 3, md: 3 }} columns={{ xs: 6, sm: 8, md: 12 }}>
                    {productionDetail.map((item) => {
                      let colorStroke = item.STATUS == 'Running' ? "#00d084" : item.STATUS == 'Completed' ? "#00d084" : "#FFFFFF"

                      const getColor = () => {
                        let color;
                        try {
                          if (item.STATUS == 'Completed') {
                            color = "#00d084"
                          } else if (item.STATUS == 'Running') {
                            color = "#e0e0e0"
                          } else if (item.STATUS == 'Not Start') {
                            color = "#FFFFFF"
                          }
                          return color;
                        }
                        catch {
                          console.log()
                        }
                      }
                      return (
                        <Grid item xs={6} md={12} lg={12} xl={12} style={{ position: "relative", padding: 6 }}>
                          <Card sx={{ bgcolor: "#ECF8F8", display: 'flex', alignItems: 'left', justifyContent: 'left' }} textAlign="left" >
                            <CardContent>
                              <Typography style={{ color: "#000000", fontSize: 18, position: "relative", left: '0vw', top: "-5px" }} textAlign="left">
                                <LensIcon fontSize="small" stroke={colorStroke} strokeWidth="2" sx={{ color: getColor() }} style={{ position: "relative", left: '0px', top: '5px' }}>{item.STATUS} </LensIcon> {item.MATERIAL_DESCRIPTION}
                              </Typography>
                              <Typography style={{ color: "#ffffff", fontSize: "16px", position: "relative", left: '-10px', top: "10px" }} textAlign="left">
                                <BarChartAccumulativeTable
                                  target={item.TARGET}
                                  actual_output={item.ACTUAL_OUTPUT}
                                  status={item.STATUS}
                                  target_now={0}
                                  unit={item.PRODUCTION_UNIT}
                                  height='50%'
                                  width='100%'
                                />
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      )
                    })}
                  </Grid>
                </Box>
              </Item>
            </Grid>
          }
        </Grid>
      </Grid>
    </>
  );
}

